

require('xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('itemDetails', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        scope: {
            details: '=?',
            sku: '=?',
            currencyCode: '=?',
            onClickLess: '&?'
        },
        controller: function controller() {/* dumb component */}
    };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/cart/itemDetails/directive.js
// module id = ../node_modules/xo-page-components/src/cart/itemDetails/directive.js
// module chunks = 0